import { CDASHIG, CDASH_MODEL, SDTM, SDTMIG, OMOPCDM,CDASH_MODEL_CN,CDASHIG_CN,SDTM_CN,SDTMIG_CN } from "./constants";
import { useStandard, StandardProvider } from "./hook/useHook";
import SearchForm from "./components/SearchForm";
import SearchHeader from "./components/SearchHeader";
import SearchTable from "./components/SearchTable";
import SearchTree from "./components/SearchTree";
import { Fragment } from "react";
import { Row, Col } from "antd";
function InnerComponent() {
  const { dictName } = useStandard();

  const columns = {
    'CDASH_Model': CDASH_MODEL,
    'CDASH_Model中文': CDASH_MODEL_CN,
    'CDASHIG': CDASHIG,
    'CDASHIG中文': CDASHIG_CN,
    'SDTM': SDTM,
    'SDTM中文':SDTM_CN,
    'SDTMIG': SDTMIG,
    'SDTMIG中文': SDTMIG_CN,
    'OMOP CDM': OMOPCDM,
  };

  return (
    <Fragment>
      <SearchHeader />
      <Row gutter={20}>
        <Col span={6}>
          <SearchTree />
        </Col>
        <Col span={18}>
          <SearchForm />
          <SearchTable columns={columns[dictName]} />
        </Col>
      </Row>
    </Fragment>
  );
}

export default function Index() {
  return (
    <StandardProvider>
      <InnerComponent />
    </StandardProvider>
  );
}
